<template>
  <div>
    <loginDialog @loginSuccess="loginSuccess"></loginDialog>
  </div>
</template>

<script>
import loginDialog from "~dlc/components/common/loginDialog";
export default {
  metaInfo:{
    title:'登录'
  },
  components: { loginDialog },
  data() {
    return {};
  },
  computed: {},
  methods: {
    loginSuccess(){
      this.$router.push('/')
    }
  },
};
</script>
